import { render, staticRenderFns } from "./WidgetAiWizard.vue?vue&type=template&id=06c937d5&scoped=true"
import script from "./WidgetAiWizard.vue?vue&type=script&lang=js"
export * from "./WidgetAiWizard.vue?vue&type=script&lang=js"
import style0 from "./WidgetAiWizard.vue?vue&type=style&index=0&id=06c937d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c937d5",
  null
  
)

export default component.exports